var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempsA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.91 250L31.0601 173.62L31.25 33.5701L163.11 109.94L162.91 250Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.05 154.57L31.1899 78.1901L31.2499 33.5701L163.11 109.94L163.05 154.57Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2198 114.91L41.4199 102.28L41.4498 81.21L63.2499 93.83L63.2198 114.91Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0601 132.19L71.25 119.56L71.28 98.49L93.09 111.11L93.0601 132.19Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.89 149.47L101.09 136.84L101.12 115.77L122.92 128.39L122.89 149.47Z",
    fill: "#29A063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 166.75L130.93 154.13L130.95 133.05L152.76 145.68L152.73 166.75Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1899 141.72L41.3799 129.09L41.4099 108.01L63.2198 120.64L63.1899 141.72Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.02 159L71.22 146.37L71.25 125.29L93.05 137.92L93.02 159Z",
    fill: "#29A063"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.86 176.28L101.05 163.65L101.08 142.57L122.88 155.2L122.86 176.28Z",
    fill: "#29A063"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M152.69 193.56L130.89 180.93L130.92 159.85L152.72 172.48L152.69 193.56Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1499 168.53L41.3398 155.9L41.3699 134.82L63.1799 147.45L63.1499 168.53Z",
    fill: "#29A063"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9801 185.81L71.1802 173.18L71.2101 152.1L93.0101 164.73L92.9801 185.81Z",
    fill: "#29A063"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.82 203.09L101.02 190.46L101.05 169.38L122.85 182.01L122.82 203.09Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.42 100.53L163.11 109.94L162.91 250L179.23 240.59L179.42 100.53Z",
    fill: "#29A063"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5601 24.1599L31.25 33.5699L163.11 109.94L179.42 100.53L47.5601 24.1599Z",
    fill: "#72D09A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.88 123.97C126.65 120.94 122.4 113.57 122.41 107.53L122.43 91.5202C122.43 88.5002 123.5 86.3802 125.22 85.4002C126.94 84.4102 129.31 84.5602 131.93 86.0702C137.16 89.1002 141.41 96.4701 141.4 102.51L141.38 118.52C141.38 121.54 140.31 123.65 138.59 124.64C136.87 125.63 134.49 125.48 131.88 123.97Z",
    fill: "#72D09A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.57 86.8301C168.57 80.8001 164.33 73.4201 159.1 70.3901C156.48 68.8701 154.1 68.7301 152.38 69.7201L130.67 82.2702L125.22 85.4002C126.94 84.4102 129.31 84.5602 131.93 86.0702C137.16 89.1002 141.41 96.4701 141.4 102.51L141.38 118.52C141.38 121.54 140.31 123.65 138.59 124.64L144.05 121.5C145.77 120.51 146.84 118.39 146.84 115.38L146.86 99.3801V100.51L163.16 91.0901L168.57 94.2301V87.9701V86.8401V86.8301Z",
    fill: "#29A063"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.48 77.4402C46.25 74.4102 42.01 67.0401 42.01 61.0101L42.03 45.0001C42.03 41.9801 43.1001 39.8601 44.8201 38.8801C46.5401 37.8901 48.91 38.0402 51.53 39.5502C56.76 42.5802 61.01 49.9501 61 55.9901L60.98 72.0001C60.98 75.0101 59.9101 77.1301 58.1901 78.1201C56.4701 79.1101 54.09 78.9601 51.48 77.4501V77.4402Z",
    fill: "#72D09A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7 23.8602C76.08 22.3402 73.7 22.2002 71.98 23.1902L50.27 35.7402L44.8201 38.8702C46.5401 37.8802 48.91 38.0302 51.53 39.5402C56.76 42.5702 61.01 49.9402 61 55.9802L60.98 71.9902C60.98 75.0002 59.9101 77.1202 58.1901 78.1102L63.65 74.9701C65.37 73.9801 66.4301 71.8602 66.4401 68.8502L66.46 53.9702L82.76 44.5502L88.17 47.7101V40.2802C88.18 34.2502 83.93 26.8701 78.7 23.8401V23.8602Z",
    fill: "#29A063"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190.729 39.6914H172.932V45.6484H190.729V39.6914Z",
    fill: "#F97E73"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M203.059 49.1152C213.386 41.2051 215.705 37.9092 215.705 32.9775C215.705 25.0918 209.431 22.3574 202.814 22.3574C198.933 22.3574 195.612 23.3096 192.707 24.7012L193.635 31.3662C195.344 30.3652 198.981 29.291 201.936 29.291C204.768 29.291 207.355 30.1211 207.355 33.5635C207.355 35.8828 206.11 38.1533 203.498 40.4482L192.414 50.1406V56H216.657V49.1152H203.059Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempsA);
export default __webpack_public_path__ + "static/media/tempsA.e563cdc418a3614dc53c526d498fdafb.svg";
export { ForwardRef as ReactComponent };